// @ts-strict-ignore
import React from 'react'
import { RichText } from '@uswitch/ev-core/react'
import { useEntities, useEntity } from '@uswitch/ev-utils/context/selectors'
import { Icon } from '../../../../atoms'
import Image from '../../../imgix-img'
import { removeWhitespaceAndSpecialChars } from '../../../helpers/commons'
import { connect } from 'react-redux'
import { brand } from '../../../../redux/app-selectors'

interface Item {
  title: string
  content: string
  icon: any
}

export interface AccordionProps {
  title: string
  name: string
  items: Array<object>
  brand: 'money' | 'uswitch' | 'confused'
}

const AccordionImage = (props: any) => {
  const { ele } = props
  const iconImage = useEntity(ele.icon)

  return (
    <>
      {iconImage.file && (
        <div className='accordion__img-mobile'>
          <Image src={iconImage.file.url} alt={ele.title} width={20} />
        </div>
      )}
    </>
  )
}

const Accordion = ({ name, title, items, brand }: AccordionProps) => {
  const data = useEntities(items)

  return (
    <div className='accordion' id={removeWhitespaceAndSpecialChars(name)}>
      {title && <h2 className='accordion__heading'>{title}</h2>}
      {data.map((ele: Item, i: number) => (
        <details key={i}>
          <summary>
            <div className='accordion__icon closed'>
              <Icon
                glyph={brand === 'confused' ? 'plus' : 'arrow-down'}
                size={24}
                color={brand === 'money' ? '#924A8B' : brand === 'confused' ? '#1F1F1F' : '#141414'}
              />
            </div>
            <div className='accordion__icon opened'>
              <Icon
                glyph={brand === 'confused' ? 'minus' : 'arrow-up'}
                size={24}
                color={brand === 'money' ? '#924A8B' : brand === 'confused' ? '#1F1F1F' : '#141414'}
              />
            </div>
            <span className='accordion__title'>
              {ele.icon && <AccordionImage ele={ele} />}
              <h3>{ele.title}</h3>
            </span>
          </summary>
          <div className='accordion__content'>
            <RichText content={ele.content} />
          </div>
        </details>
      ))}
    </div>
  )
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Accordion)
